// Keep in sync with ANALYSIS_WORD_LIMIT in apps/backend/src/routes/feedback.ts
export const ANALYSIS_WORD_LIMIT = 5000;

// Keep in sync with USER_NOTES_LIMIT in apps/backend/src/routes/notes.ts
export const USER_NOTES_LIMIT = 100;

